import { Box, RadioGroup, RadioItem, TextField } from 'braid-design-system';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { parseLabel } from '../parseLabel.tsx';
import type { FormFieldWithOptions } from '../types.ts';

interface SelectProps {
  element: FormFieldWithOptions;
}

// TODO: Look into columns for RadioItem components
export const Select = ({ element }: SelectProps) => {
  const { watch, setValue } = useFormContext();
  const otherFieldName = `${element.id}-other-text`;
  const otherText = watch(otherFieldName) || '';
  const label = useMemo(
    () => parseLabel(element.id, element.label, element.labelLinks),
    [element.id, element.label, element.labelLinks],
  );
  return (
    <Controller
      key={element.id}
      name={element.id}
      rules={{
        required: element.required ? 'This field is required' : false,
      }}
      render={({ field, fieldState }) => {
        const radioItems = element.options?.map((option) => (
          <RadioItem key={option.id} value={option.value} label={option.label}>
            {option.image && (
              <Box>
                <img
                  src={option.image.src}
                  alt={option.image.alt}
                  style={{
                    width: option.image.width || 'auto',
                    height: option.image.height || 'auto',
                    maxWidth: '100%',
                  }}
                />
              </Box>
            )}
          </RadioItem>
        ));

        if (element.other) {
          radioItems.push(
            <RadioItem key={`${element.id}-other`} value="other" label="Other">
              <TextField
                aria-labelledby={`${element.id}-other`}
                name={otherFieldName}
                value={otherText}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setValue(otherFieldName, e.target.value);
                  if (field.value === 'other') {
                    field.onChange('other');
                  }
                }}
                onFocus={() => {
                  field.onChange('other');
                }}
                message={fieldState.error?.message}
                tone={fieldState.invalid ? 'critical' : undefined}
              />
            </RadioItem>,
          );
        }

        return (
          <RadioGroup
            label={label}
            secondaryLabel={element.secondaryLabel}
            onChange={field.onChange}
            value={field.value}
            message={fieldState.error?.message}
            tone={fieldState.invalid ? 'critical' : undefined}
          >
            {radioItems}
          </RadioGroup>
        );
      }}
    />
  );
};
